import { onValue, ref } from "firebase/database";
import { db } from "../lib/firebase";
import types from "../types";
import { normalizeAgencyIdsFromSnapshot } from "../utils/agenciesFeatureFlags";

export const startListenerAgenciesFeatureFlags = () => async (dispatch) => {
  try {
    const dbRef = ref(db, "agenciesFeatureFlags");
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val() ?? {};
      dispatch(
        setAgenciesFeatureFlags({
          importCampaigns: normalizeAgencyIdsFromSnapshot(data.importCampaigns),
          creativeTemplates: normalizeAgencyIdsFromSnapshot(
            data.creativeTemplates
          ),
        })
      );
    });
  } catch (error) {
    console.log(error);
    return false;
  }
};

const setAgenciesFeatureFlags = (data) => ({
  type: types.SET_AGENCIES_FEATURE_FLAGS,
  payload: data,
});
